module.exports = __webpack_public_path__ + "img/6@2x.86be6793.png";